
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import { addSmsNum } from "@/api/api-basic-sms";
import i18n from "@/config/i18n";
@Component
export default class PiMessagerecharge extends Vue {
  private modalShow = false;
  private loading = false;
  private modalTitle = i18n.t("messageManage.rechange");
  private FormData: objAny = {};

  private ruleInline: objAny = {
    number: [
      {
        required: true,
        validator: regular.int,
        trigger: "blur",
        name: " " + i18n.t("messageManage.addNum")
      }
    ]
  };
  private formItem: objAny = {
    number: ""
  };

  public open() {
    this.modalShow = true;
    this.formItem.number = "";
  }

  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  public handleSubmit() {
    const formItem: objAny = this.$refs.formItem;
    formItem.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await addSmsNum(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
